import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['red', 'teal', 'orange', 'productid', 'subscriptionplans', 'planprice', 'plansessions', 'planproductname']

  selectProduct (element) {
    if (element.toElement.id.includes('teal')) {
      this.tealTargets.forEach(element => { element.classList.add("active") })
      this.redTargets.forEach(element => { element.classList.remove("active") })
      this.orangeTargets.forEach(element => { element.classList.remove("active") })

      let product_id = element.toElement.id.split('_')[0];

      this.productidTargets.forEach(element => {
        if (element.id == 'teal') {
          element.value = product_id;
        }
      })

      document.getElementsByClassName("active-plan")[0].classList.add("display-none");
      document.getElementsByClassName("active-plan")[0].classList.remove("active-plan");
      document.getElementById(element.toElement.id.split('_')[0] + '_subscription-product-plans').classList.remove("display-none");
      document.getElementById(element.toElement.id.split('_')[0] + '_subscription-product-plans').classList.add("active-plan");
    }
    else if (element.toElement.id.includes('orange')) {
      this.orangeTargets.forEach(element => { element.classList.add("active") })
      this.redTargets.forEach(element => { element.classList.remove("active") })
      this.tealTargets.forEach(element => { element.classList.remove("active") })

      let product_id = element.toElement.id.split('_')[0];

      this.productidTargets.forEach(element => {
        if (element.id == 'orange') {
          element.value = product_id;
        }
      })

      document.getElementsByClassName("active-plan")[0].classList.add("display-none");
      document.getElementsByClassName("active-plan")[0].classList.remove("active-plan");
      document.getElementById(element.toElement.id.split('_')[0] + '_subscription-product-plans').classList.remove("display-none");
      document.getElementById(element.toElement.id.split('_')[0] + '_subscription-product-plans').classList.add("active-plan");
    }
    else {
      this.redTargets.forEach(element => { element.classList.add("active") })
      this.orangeTargets.forEach(element => { element.classList.remove("active") })
      this.tealTargets.forEach(element => { element.classList.remove("active") })

      let product_id = element.toElement.id.split('_')[0];

      this.productidTargets.forEach(element => {
        if (element.id == 'red') {
          element.value = product_id;
        }
      })

      document.getElementsByClassName("active-plan")[0].classList.add("display-none");
      document.getElementsByClassName("active-plan")[0].classList.remove("active-plan");
      document.getElementById(element.toElement.id.split('_')[0] + '_subscription-product-plans').classList.remove("display-none");
      document.getElementById(element.toElement.id.split('_')[0] + '_subscription-product-plans').classList.add("active-plan");
    }
  }

  selectPlan (elem) {
    var arr = elem.toElement.id.split('_');
    var id = arr[arr.length - 1];
    var childdivs = document.getElementById(id + '_plan_details').children;
    var elements = [];

    for( var i=0; i < childdivs.length; i++ ) {
      elements.push(childdivs[i]);
    }

    this.plansessionsTargets.forEach(element => { element.innerText = elements[0].innerText});
    this.planproductnameTargets.forEach(element => { element.innerText = elements[1].innerText});
    this.planpriceTargets.forEach(element => { element.innerText = elements[2].innerText});
  }
}
